import { graphql } from 'gatsby';

import { getKey } from '../../../helpers';

/**
 * @param {any} props
 * @param {string} locale
 */
export const heroV2Mapping = (props, locale) => {
  return {
    title: getKey(props, `title_${locale}`),
    description: getKey(props, `description_${locale}`),
    textCall: getKey(props, `textCall_${locale}`),
    urlCall: getKey(props, `urlCall_${locale}`),
    subtitle: getKey(props, `subtitle_${locale}`),
    bottomText: getKey(props, `bottomText_${locale}`),
    fluid: getKey(props, `image.large.childImageSharp.fluid`),
    multimediaContent: props?.multimediaContent,
    height: props?.height,
    linearGradient: props?.linearGradient,
  };
};

/**
 * GraphQL Query
 */
export const query = graphql`
  fragment Herolp on StrapiWidgetrels {
    herolp {
      key: id
      title_en
      title_es
      subtitle_en
      subtitle_es
      description_es
      description_en
      textCall_en
      textCall_es
      urlCall_en
      urlCall_es
      bottomText_en
      bottomText_es
      image {
        large {
          childImageSharp {
            fluid(maxWidth: 1840, quality: 90) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
      multimediaContent
      height
      linearGradient
      widgetPosition
    }
  }
`;
